import InfoWithLabel from './InfoWithLabel.component';

export default InfoWithLabel;